// noinspection ES6UnusedImports
import React from 'react';
import Icon from '@bonprix/pattern-library/templates/icon';
import LandmarkAdapter from '@core/scripts/components/landmark-adapter';

export default function ProductionFacilities({productionFacilities, texts, moreLinkUrl}) {
    const onMoreLinkClicked = () => LandmarkAdapter.sendClickLandmark('adp_factories_info');

    const introductionText =
        productionFacilities.length === 1
            ? texts.production_facilities_introduction_single
            : texts.production_facilities_introduction_multiple;

    return (
        <div className="production-facilities">
            <div className="production-facilities__introduction">{introductionText}</div>
            <div className="production-facilities__facilities">
                {productionFacilities.map((productionFacility, index) => (
                    <div key={'prod-fac-' + index} className="production-facilities__facility">
                        <div>
                            {productionFacility.name}, {productionFacility.location}
                        </div>
                        <div>{productionFacility.country}</div>
                    </div>
                ))}
                <div className="production-facilities__working-conditions">
                    <Icon name="production-facilities" className="production-facilities__working-conditions-icon" />
                    <div>
                        <div>{texts.production_facilities_working_conditions}</div>
                        <a
                            target="_blank"
                            href={moreLinkUrl}
                            onClick={onMoreLinkClicked}
                            className="production-facilities__working-conditions-more-link"
                        >
                            <span className="link__container">
                                <span>{texts.production_facilities_more_link}</span>
                                <Icon name="arrow-right" className="link__icon" />
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}
